const previasgratis = {
  portugues: {
    pageTitle: "Bella da Semana — Acesso liberado",
    pageDescription:
      "Acesso liberado ao ensaio exclusivo do Especial Marcela e Mel — Bella da Semana.",
    logoAlt: "Bella da Semana",
    imageAlt: "Cena do ensaio especial Marcela e Mel em um sofá claro",
    imageLabel: "BELLA DA SEMANA / EXCLUSIVO",
    playLabel: "Ver a prévia do ensaio",
    adultsOnly: "CONTEÚDO PARA MAIORES DE 18",
    eyebrow: "CONVITE PRIVADO",
    title1: "Sua entrada",
    title2: "foi liberada.",
    intro:
      "Coloque seu e-mail abaixo e receba o ensaio exclusivo do <strong>Especial Marcela e Mel</strong> e entenda por que, desde 2001, o Bella da Semana é o clube do Homem Raiz.",
    fieldLabel: "Email:",
    placeholder: "seu melhor e-mail",
    button: "ENVIAR",
    sending: "ENVIANDO",
    consent:
      "Ao se cadastrar, você concorda em receber e-mails de marketing do Bella da Semana. A frequência pode variar, e você pode cancelar a inscrição a qualquer momento pelo link no fim de cada e-mail.",
    invalidEmail: "Digite um e-mail válido para continuar.",
    success: "Pronto! Confira sua caixa de entrada nos próximos minutos.",
    failure: "Não foi possível enviar agora. Tente de novo em instantes.",
    toastSuccess: "Cadastro feito",
    playHint: "Coloque seu e-mail para receber o ensaio.",
    footerLeft: "DESDE 2001",
    footerRight: "BELLA DA SEMANA",
  },
  ingles: {
    pageTitle: "Bella Club — Access unlocked",
    pageDescription:
      "Access unlocked to the exclusive Marcela & Mel Special photo shoot — Bella Club.",
    logoAlt: "Bella Club",
    imageAlt: "Scene from the Marcela & Mel special photo shoot on a light sofa",
    imageLabel: "BELLA CLUB / EXCLUSIVE",
    playLabel: "See the photo shoot preview",
    adultsOnly: "ADULTS ONLY (18+)",
    eyebrow: "PRIVATE INVITATION",
    title1: "Your access",
    title2: "is unlocked.",
    intro:
      "Enter your e-mail below to get the exclusive <strong>Marcela & Mel Special</strong> photo shoot, and see why Bella Club has been the club for real men since 2001.",
    fieldLabel: "Email:",
    placeholder: "your best e-mail",
    button: "SEND",
    sending: "SENDING",
    consent:
      "By signing up, you agree to receive marketing e-mails from Bella Club. Frequency may vary, and you can unsubscribe at any time using the link at the end of each e-mail.",
    invalidEmail: "Enter a valid e-mail to continue.",
    success: "Done! Check your inbox in the next few minutes.",
    failure: "We couldn't send it right now. Please try again in a moment.",
    toastSuccess: "You're in",
    playHint: "Enter your e-mail to get the photo shoot.",
    footerLeft: "SINCE 2001",
    footerRight: "BELLA CLUB",
  },
};

export default previasgratis;
